// extracted by mini-css-extract-plugin
module.exports = {"stageFlag":"EnvironmentLabel_stageFlag__0ZBSA","stageText":"EnvironmentLabel_stageText__yrnWE","localColor":"EnvironmentLabel_localColor__z_ChJ"};